import React, { useRef, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Toast } from "bootstrap";
import TaizoLogo from "../assets/images/Taizo.png";
import notificationSound from "../assets/audio/NotificationSound.mp3";
import { useDispatch } from "react-redux";
import { notiDetailsActions } from "../redux-store/store";

const ToastComponent = ({ triggerToast }) => {
  const toastRef = useRef(null);
  const audioRef = useRef(null);
  const Dispatch = useDispatch();

  const handlePlayAudio = () => {
    if (audioRef.current) {
      audioRef.current.play().catch((error) => {
        console.error("Audio playback failed:", error);
      });
    }
  };

  useEffect(() => {
    if (triggerToast) {
      const toastElement = new Toast(toastRef.current);
      toastElement.show();
      handlePlayAudio();
      Dispatch(notiDetailsActions.setShowReddot(true));
    }
  }, [triggerToast]);

  return (
    <div className="toast-container position-fixed bottom-0 end-0 p-3">
      <button onClick={handlePlayAudio} style={{ display: "none" }}>
        Play Sound
      </button>
      <div
        ref={toastRef}
        id="liveToast"
        className="toast"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div className="toast-header">
          <img
            src={TaizoLogo}
            className="rounded me-2"
            alt="..."
            width={30}
            height={30}
          />
          <strong className="me-auto">Notification</strong>
          <small>Just now</small>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="toast"
            aria-label="Close"
          ></button>
        </div>
        <div className="toast-body">New meta lead arrived.</div>
        <audio ref={audioRef} src={notificationSound} />
      </div>
    </div>
  );
};

export default ToastComponent;
